import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useActiveGroup } from '@/hooks/useActiveGroup';
import { Users } from 'lucide-react';

/**
 * TeamSelector - Select active team (formerly GroupSelector)
 *
 * Now uses teams instead of groups, but maintains backwards compatibility.
 */
export function TeamSelector() {
  const { activeTeam, setActiveTeam, teams, hasTeams } = useActiveGroup();

  if (!hasTeams) {
    return null;
  }

  // If only one team, show it as text instead of dropdown
  if (teams.length === 1) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground px-2">
        <Users className="h-4 w-4" />
        <span>{teams[0].name}</span>
      </div>
    );
  }

  return (
    <Select value={activeTeam?.id || ''} onValueChange={setActiveTeam}>
      <SelectTrigger className="w-[180px] h-8">
        <Users className="h-4 w-4 mr-2" />
        <SelectValue placeholder="Select team" />
      </SelectTrigger>
      <SelectContent>
        {teams.map((team) => (
          <SelectItem key={team.id} value={team.id}>
            <div className="flex items-center justify-between w-full">
              <span>{team.name}</span>
              <span className="text-xs text-muted-foreground ml-2">
                {team.role}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

// Backwards compatibility alias
export const GroupSelector = TeamSelector;

export default TeamSelector;
